import React, { useEffect, useState } from 'react';
import { teamAPI } from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Cake } from 'lucide-react';

// Muestra un recordatorio cuando falten pocos dias (<= WINDOW_DAYS) para el cumple de alguien.
const WINDOW_DAYS = 14;
const MONTHS = ['', 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

function daysUntilBirthday(day, month) {
  if (!day || !month) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  let next = new Date(today.getFullYear(), month - 1, day); next.setHours(0, 0, 0, 0);
  if (next < today) next = new Date(today.getFullYear() + 1, month - 1, day);
  return Math.round((next - today) / (1000 * 60 * 60 * 24));
}

export function BirthdayReminder() {
  const [upcoming, setUpcoming] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const team = await teamAPI.getAll();
        if (!mounted) return;
        const list = team
          .filter((m) => m.profile?.birthday_day && m.profile?.birthday_month)
          .map((m) => ({ id: m.id, name: m.name, day: m.profile.birthday_day, month: m.profile.birthday_month, dias: daysUntilBirthday(m.profile.birthday_day, m.profile.birthday_month) }))
          .filter((m) => m.dias !== null && m.dias <= WINDOW_DAYS)
          .sort((a, b) => a.dias - b.dias);
        setUpcoming(list);
      } catch (e) { /* ceo/manager/member only */ }
    })();
    return () => { mounted = false; };
  }, []);

  if (upcoming.length === 0) return null;

  return (
    <Card className="border-pink-200 bg-pink-50/60" data-testid="birthday-reminder">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2 text-pink-700">
          <Cake className="w-5 h-5" /> Próximos cumpleaños
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
        {upcoming.map((m) => (
          <div key={m.id} className="flex items-center gap-3 rounded-lg bg-white px-3 py-2 border border-pink-100" data-testid={`birthday-reminder-${m.id}`}>
            <div className="w-9 h-9 rounded-full bg-pink-100 flex items-center justify-center flex-shrink-0"><Cake className="w-4 h-4 text-pink-600" /></div>
            <div>
              <p className="text-sm font-medium leading-tight">{m.name}</p>
              <p className="text-xs text-muted-foreground">{m.day} de {MONTHS[m.month]}</p>
            </div>
            <Badge className="bg-pink-100 text-pink-700 ml-1">{m.dias === 0 ? '¡Hoy! 🎉' : m.dias === 1 ? 'Mañana' : `En ${m.dias} días`}</Badge>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
